import React, { memo, useCallback } from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { useIntl } from '@atlassian/jira-intl';
import {
	useOnboarding,
	RENAME_ONBOARDING,
} from '@atlassian/jira-business-onboarding-board-saved-views/src/controllers/onboarding-context.tsx';
import { NewLozenge } from '@atlassian/jira-business-onboarding-board-saved-views/src/ui/NewLozenge.tsx';
import messages from './messages.tsx';

type Props = {
	onClick: () => void;
};

export const RenameItem = memo(({ onClick }: Props) => {
	const { formatMessage } = useIntl();
	const [isRenameLozengeVisible, markRenameAsSeen] = useOnboarding(RENAME_ONBOARDING);

	const handleClick = useCallback(() => {
		markRenameAsSeen();
		onClick();
	}, [markRenameAsSeen, onClick]);

	return (
		<DropdownItem onClick={handleClick}>
			{formatMessage(messages.renameItem)}
			{isRenameLozengeVisible && <NewLozenge />}
		</DropdownItem>
	);
});
